// Environment configuration for the application
const isDev = import.meta.env.DEV;

const normalizeApiBaseUrl = (baseUrl) => {
    if (!baseUrl || typeof baseUrl !== 'string') {
        return baseUrl;
    }

    const trimmed = baseUrl.replace(/\/$/, '');

    if (!isDev && trimmed.startsWith('http://')) {
        if (
            trimmed.startsWith('http://localhost') ||
            trimmed.startsWith('http://127.0.0.1') ||
            trimmed.startsWith('http://[::1]')
        ) {
            return trimmed;
        }

        return trimmed.replace('http://', 'https://');
    }

    if (trimmed.startsWith('http://api.clinexpert.org')) {
        return trimmed.replace('http://', 'https://');
    }

    if (trimmed.startsWith('http://clinexpert.org')) {
        return trimmed.replace('http://', 'https://');
    }

    return trimmed;
};

const defaultApiBaseUrl = isDev ? 'http://localhost:8000' : 'https://api.clinexpert.org';

const config = {
    // API Configuration
    API_BASE_URL: normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL || defaultApiBaseUrl),
    
    // Environment
    NODE_ENV: import.meta.env.VITE_NODE_ENV || 'development',
    
    // Feature flags
    DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true' || false,
    
    // Timeouts
    API_TIMEOUT: 30000, // Default timeout for most operations (30 seconds)
    AUTH_TIMEOUT: 80000, // Extended timeout for auth operations (80 seconds) to handle Render cold starts
    
    // Pagination defaults
    DEFAULT_PAGE_SIZE: 20,
    
    // Local storage keys
    STORAGE_KEYS: {
        ACCESS_TOKEN: 'access_token',
        REFRESH_TOKEN: 'refresh_token',
        USER_INFO: 'user_info',
        THEME: 'theme'
    }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
    // Remove leading slash if present to avoid double slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    let base = config.API_BASE_URL;
    // Runtime guard: if the page is served over HTTPS, the API must also be HTTPS.
    // This catches env-var misconfiguration and FastAPI trailing-slash redirects
    // that can generate http:// Location headers when behind a proxy without
    // X-Forwarded-Proto set (causing "mixed active content" blocks in the browser).
    if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
        base = base.replace(/^http:\/\//, 'https://');
    }
    return `${base}/${cleanEndpoint}`;
};

// Helper function to check if we're in production
export const isProduction = () => config.NODE_ENV === 'production';

// Helper function to check if debug mode is enabled
export const isDebugMode = () => config.DEBUG_MODE;

export default config;
